const AdvisorActionTypes = {
    UPDATE_ADVISORS: "UPDATE_ADVISORS",
    UPDATE_ADVISORS_STATUS: "UPDATE_ADVISORS_STATUS",
    UPDATE_ADVISORS_PARTNER: "UPDATE_ADVISORS_PARTNER",
};
  
export default AdvisorActionTypes;
